import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import Routes from './Routes'
import Store from './Redux/Store';
import { Provider } from 'react-redux';
import './Styles/Styles.scss'
import { ToastContainer } from 'react-toastify';
import axios from 'axios'
import Helpers from './Components/Helpers/Helpers';
import { setSession } from './Redux/Actions'
import RedesignPreview from './Views/Preview/RedesignPreview'
import { BrowserRouter } from 'react-router-dom'

//
// ─── VALIDACION DE SESION ───────────────────────────────────────────────────────
//
const App = () => {
  const isRedesignPreview = window.location.pathname === '/preview-redesign';
  const isLoginRoute = window.location.pathname === '/login' || window.location.pathname === '/login/empresariosindependientes';
  const hasSession = Helpers.localStorage.existsJWT();
  const authContent = <Provider store={Store}>
    <Routes type="auth" />
    <ToastContainer />
  </Provider>;
  const preloader = <div style={{
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'fixed'
  }}>
    <img src={Helpers.config.resourcesUrl({ url: '/images/dashboard/preloading.svg' })} alt="Preloading" />
  </div>;
  const [content, setContent] = useState(isLoginRoute || !hasSession ? authContent : preloader);

  useEffect(() => {
    if (isRedesignPreview) return;
    const showLogin = () => {
      Helpers.localStorage.clearJWT();
      setContent(authContent);
    }
    // En una computadora nueva no existe sesión que validar. Mostrar el login
    // inmediatamente evita dejar el navegador esperando una petición innecesaria.
    if (isLoginRoute || !hasSession) {
      if (isLoginRoute) Helpers.localStorage.clearJWT();
      return;
    }
    // if (Helpers.date.get({ format: '%Y-%m-%d' }) >= '2026-03-01') {
    //   return <></>
    // } else {
      axios({
        url: Helpers.config.api.url + '/users/session',
        method: 'POST',
        timeout: 12000,
        data: {
          jwt: Helpers.localStorage.getJWT()
        }
      }).then(res => {
        return res.data;
      }).then(res => {
        /* if (Helpers.date.get({ format: '%Y-%m-%d' }) < '2023-12-01') { */
        if (res.message === 'error_session_api') {
          showLogin();
        } else {
          Store.dispatch(setSession(res.data));
          Helpers.localStorage.setSession({
            jwt: res.data.jwt
          });
          setContent(<Provider store={Store}>
            <Routes />
            <ToastContainer />
          </Provider>);
        }
        /* } */
      }).catch(req => {
        console.log(req);
        showLogin();
      });
    // }
  }, [isRedesignPreview, isLoginRoute, hasSession]);

  return isRedesignPreview ? <BrowserRouter><RedesignPreview /></BrowserRouter> : content;
}

ReactDOM.render(
  <App />,
  document.getElementById('root')
);

/* console.log('%cCARLOS ESTHEFANO HUAMAN MARCOS', 'color: RED; font-size: 20px; font-weight: bold');
console.log('%cDESARROLLADOR DE SOFTWARE', 'color: RED; font-size: 15px; font-weight: bold');
console.log('%cPERU', 'color: RED; font-size: 15px; font-weight: bold');
console.log('%cWHATSAPP +51 989998352', 'color: RED; font-size: 15px; font-weight: bold');
console.log('%cEMAIL carhuaman1995@gmail.com', 'color: RED; font-size: 15px; font-weight: bold'); */

console.log('%cSYSTEM DEVS', 'color: #0F5969; font-size: 20px; font-weight: bold');

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
